<p-toast></p-toast>
<p-confirmDialog key="confirm-bad-supplier" header="Confirmation" icon="pi pi-exclamation-triangle">
	<ng-template pTemplate="message" let-message>
		<div class="flex flex-column gap-2 ml-4">
			<p>{{message.message}}</p>
			<div class="flex flex-column gap-2">
				<label for="raison">Raison</label>
				<input type="text" pInputText [(ngModel)]="raison">
			</div>
		</div>
	</ng-template>
</p-confirmDialog>



<p-card *ngIf="!EstCharge()">
	<div class="fluid formgrid grid">
		<div class="flex flex-column gap-2 col-12 text-center">
			<p-progressSpinner></p-progressSpinner>
		</div>
	</div>
</p-card>

<div *ngIf="EstCharge()" class="grid">
	<div class="col-12">
		<p-card>
			<h5 >Bon de commande
				<span class="statut nouveau">
					Nouveau
				</span>
			</h5>
			<p-menubar autoDisplay="false" [model]="menu"></p-menubar>
		</p-card>
	</div>
</div>


<div *ngIf="EstCharge()" class="grid">
	<div class="col-12">
		<p-card>
			<div class="fluid formgrid grid my-2">
				<div class="col-12 md:col-6 lg:col-3 mb-3">
					<p-selectButton [options]="listeTypeBdc" [(ngModel)]="typeBdc" optionLabel="valeur">
					</p-selectButton>
					<small class="p-error" *ngIf="submitted && !typeBdc">Le type de bon de commande est
						obligatoire.</small>
				</div>
			</div>
			<div class="fluid formgrid grid my-2">
				<div class="flex flex-column gap-2 col-12 md:col-6 lg:col-3">
					<label for="lastname">Date<span class="requis">*</span></label>
					<p-calendar appendTo="body" showIcon=true [(ngModel)]="dateBonCommande" dateFormat="yy-mm-dd"
						[yearNavigator]="true" [monthNavigator]="true" yearRange="2000:2040"></p-calendar>
				</div>

				<div class="flex flex-column gap-2 col-12 md:col-6 lg:col-3">
					<label for="codeProjet">Code projet<span class="requis">*</span></label>
					<p-dropdown #champCodeProjet [options]="listeCodeProjet" [(ngModel)]="selectionCodeProjet"
						optionLabel="code" [showClear]="true" filter="true"
						filterBy="code,nom" appendTo="body"
						placeholder="Sélectionner un code de projet...">
						<ng-template pTemplate="selectedItem">
							<div *ngIf="selectionCodeProjet">
								<div>{{selectionCodeProjet.code}}</div>
							</div>
						</ng-template>
						<ng-template let-code pTemplate="item">
							<div>
								<div>{{code.code}} - {{code.nom}}</div>
							</div>
						</ng-template>
					</p-dropdown>
					<small class="p-error" *ngIf="submitted && !selectionCodeProjet">Le code de projet est
						obligatoire.</small>
				</div>

				<div class="flex flex-column gap-2 col-12 lg:col-3">
					<label for="lastname">Fournisseur<span class="requis">*</span></label>
					<p-dropdown [options]="fournisseurs" [(ngModel)]="selectionFournisseur" optionLabel="nom" [virtualScroll]="true"
						[virtualScrollItemSize]="38" [showClear]="true" filter="true" filterBy="numero,nom"
						placeholder="Sélectionner un fournisseur..." (onChange)="surChangementFournisseur()">
						<ng-template pTemplate="selectedItem">
							<div *ngIf="selectionFournisseur">
								<div class="flex align-items-center gap-2" tooltipPosition="left" pTooltip="{{selectionFournisseur.nom}} ({{selectionFournisseur.numero}})">
									<p-tag [severity]="fournisseurService.getQualityScore(selectionFournisseur)"
										[value]="fournisseurService.getQualityScoreLabel(selectionFournisseur)">
									</p-tag>
									<div>{{selectionFournisseur.nom}} ({{selectionFournisseur.numero}})</div>
								</div>
							</div>
						</ng-template>
						<ng-template let-fournisseur pTemplate="item">
							<div class="flex align-items-center gap-2" tooltipPosition="left"  pTooltip="{{fournisseur.nom}} ({{fournisseur.numero}})">
								<p-tag [severity]="fournisseurService.getQualityScore(fournisseur)"
									[value]="fournisseurService.getQualityScoreLabel(fournisseur)">
								</p-tag>
								<div>{{fournisseur.nom}} ({{fournisseur.numero}})</div>
							</div>
						</ng-template>
					</p-dropdown>
					<small *ngIf="raison">{{raison}}</small>
					<small class="p-error" *ngIf="submitted && !selectionFournisseur">Le fournisseur est
						obligatoire.</small>
				</div>
				<div class="flex flex-column gap-2 col-12 lg:col-3">
					<label for="lastname">Fréquence</label>
					<p-dropdown [options]="frequences" [(ngModel)]="selectionFrequence" optionLabel="valeur"
					 filter="true" filterBy="numero,nom"
						placeholder="Sélectionner une fréquence..." (onChange)="surChangementFrequence()">
						<ng-template pTemplate="selectedItem">
							<div *ngIf="selectionFrequence">
								<div>{{selectionFrequence.valeur}}</div>
							</div>
						</ng-template>
						<ng-template let-frequence pTemplate="item">
							<div>
								<div>{{frequence.valeur}}</div>
							</div>
						</ng-template>
					</p-dropdown>
				</div>

			</div>

			<div class="fluid formgrid grid my-2">
				<div class="flex flex-column gap-2 col-12 md:col-6 lg:col-3">
					<label for="lastname">Requis le</label>
					<p-calendar appendTo="body" showIcon=true [(ngModel)]="requisLe" dateFormat="yy-mm-dd"
						[yearNavigator]="true" [monthNavigator]="true" yearRange="2000:2040"></p-calendar>
				</div>
				<div class="flex flex-column gap-2 col-12 md:col-6 lg:col-3">
					<label for="lastname">Adresse de livraison<span class="requis">*</span></label>
					<app-selection-adresse-emplacement [(ngModel)]="selectedAddress" [(emplacementId)]="selectedEmplacementId"></app-selection-adresse-emplacement>
					<small class="p-error" *ngIf="submitted && !selectedAddress">L'adresse de livraison est
						obligatoire.</small>
				</div>
				<div class="flex flex-column gap-2 col-12 md:col-6 lg:col-3">
					<label for="creerequisition">Créer automatiquement une réquisition? <app-help-tooltip text="Créer automatiquement une réquisition au moment que le bon de commande est complété si la fréquence est Aucune. Cela va l'ajouter à l'inventaire de l'emplacement de livraison." position="right"></app-help-tooltip></label>
					<p-toggleButton 
						[(ngModel)]="creerRequisition" 
						onLabel="Oui" 
						offLabel="Non" 
						onIcon="pi pi-check" 
						offIcon="pi pi-times"
						[disabled]="selectionFrequence.cle != 'N'" />
				</div>
			</div>

			<div class="fluid formgrid grid my-2">
				<div class="flex flex-column gap-2 col-12">
					<label for="note">Note</label>
					<input #champNote type="text" pInputText id="note" [(ngModel)]="note"
						autocomplete="off" />
				</div>
			</div>
			<!-- <div class="fluid formgrid grid">
				<div class="flex flex-column gap-2 col-12">
					<label for="conditions">Conditions</label>
					<input #champNote type="text" pInputText id="conditions" [(ngModel)]="conditions"
						autocomplete="off" />
				</div>
			</div> -->
			<div class="flex justify-content-end mt-3">
				<p-button label="Ajouter" (click)="CreerBdc()" icon="pi pi-save" iconPos="left"></p-button>
			</div>
		</p-card>
	</div>


</div>